import React from 'react';
import { PropTypes } from 'prop-types';
import CircleCheckMarkIcon from '@icons/CircleCheckMarkIcon';
import CircleDangerIcon from '@icons/CircleDangerIcon';
import CircleRefreshIcon from '@icons/CircleRefreshIcon';
import Circle from '@atoms/Circle';

const MemberStatusIcon = ({ statusText }) => (
    <>
        {statusText === 'Active' && (
            <Circle status="success">
                <CircleCheckMarkIcon />
            </Circle>
        )}
        {statusText === 'Inactive' && (
            <Circle status="error">
                <CircleDangerIcon />
            </Circle>
        )}
        {statusText === 'Expiring Soon' && (
            <Circle status="warning">
                <CircleRefreshIcon />
            </Circle>
        )}
    </>
);

MemberStatusIcon.propTypes = {
    statusText: PropTypes.string.isRequired,
};

export default MemberStatusIcon;
